import purify from "dompurify";

export default {
    errorHandlerForResponder: function (error) {

        if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
            return purify.sanitize(error.response.data.error.message);
        }

        if (error.response && error.response.data && error.response.data.message) {
            return purify.sanitize(error.response.data.message);
        }

        if (error.response && error.response.data && error.response.data.error) {
            return purify.sanitize(error.response.data.error.toString());
        }


        try {
            return purify.sanitize(error.toString());
        } catch (e) {
            console.log(e);
        }

        try {
            return purify.sanitize(JSON.stringify(error));
        } catch (e) {
            console.log(e);
        }

        return 'General server error';
    },

    forceModal: function (error) {
        return error.response && error.response.data && error.response.data.error && error.response.data.error.hasOwnProperty('modal') && error.response.data.error.modal === true;
    },

    validateEmailAddress: function (value) {
        // javascript regex taken from here: https://web.archive.org/web/20220110004418/https://emailregex.com/
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ig.test(value)
    },
    purify: function (strings, ...values) {
        const dirty = strings.reduce((prev, next, i) => `${prev}${next}${values[i] || ''}`, '');
        return purify.sanitize(dirty);
    }
}
